module.exports = __webpack_public_path__ + "assets/c8d8d40897cd1a045880dafe4395f1a6.png";